import { InMemoryCache } from 'apollo-cache-inmemory/lib/inMemoryCache'
import gql from 'graphql-tag'
import get from 'lodash-es/get'

export const customerDefaults = {
  Customer: {
    __typename: 'Customer',
    lastViewedPurchasePage: 1,
    lastViewedPurchaseContext: 'notPublished'
  }
}

export const customerResolvers = {
  Customer: {
    lastViewedPurchasePage: (obj, args, { cache }) => {
      const customer = cache.readFragment({
        fragment: gql`
          fragment lastViewedPurchasePage on Customer { lastViewedPurchasePage }
        `,
        id: `Customer:${obj.id}`
      })
      return get(customer, 'lastViewedPurchasePage', 1)
    },
    lastViewedPurchaseContext: (obj, args, { cache }) => {
      const customer = cache.readFragment({
        fragment: gql`
          fragment lastViewedPurchaseContext on Customer { lastViewedPurchaseContext }
        `,
        id: `Customer:${obj.id}`
      })
      return get(customer, 'lastViewedPurchaseContext', 'notPublished')
    }
  },
}

export const customerMutations = {
  updateCustomerUI: (_, args: { id: number, updates: any }, ctx: { cache: InMemoryCache }) => {
    const updates = args.updates
    ctx.cache.writeData({ id: `Customer:${args.id}`, data: { ...updates } })
    return null
  },
}
